export enum LocaleByCurrency {
  ARS = 'es-AR',
  AUD = 'en-AU',
  BRL = 'pt-BR',
  CAD = 'en-CA',
  CHF = 'fr-SW',
  CLP = 'es-CL',
  COP = 'es-CO',
  EUR = 'fr',
  GBP = 'en-GB',
  KRW = 'kr',
  MXN = 'es-MX',
  NGN = 'en-NG',
  PEN = 'es-PE',
  TWD = 'tw',
  UYU = 'es-UY',
  USD = 'en',
  JPY = 'ja',
}

export interface IIncomeRange {
  min: number | null;
  max: number | null;
}

export interface IIncomeRangeResponse {
  currency: string;
  ranges: { [key: string]: IIncomeRange };
}

export interface MemberQsaResponse {
  document: string;
  name: string;
  participationPercentage: number;
  partnerCode: string;
}
